module.exports = __webpack_public_path__ + "static/media/Tri Chorus HD VR.42e96b8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/hd-racks/Tri Chorus HD VR.mp3
// module id = o2/C
// module chunks = 13